import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Beranda', path: '/' },
    { name: 'Tentang Kami', path: '/about' },
    { name: 'Layanan', path: '/layanan' },
    { name: 'Testimoni', path: '/testimoni' },
    { name: 'Legal', path: '/legal' },
    { name: 'Kontak', path: '/kontak' },
  ];

  const isActive = (path) => location.pathname === path;

  // Function to handle clicking the same page link - manually scroll to top
  const handleLinkClick = (path) => {
    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white sticky top-0 z-50 border-b border-divider">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <Link 
              to="/" 
              onClick={() => handleLinkClick('/')} 
              className="flex items-center rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
              aria-label="Beranda Akademika Support"
            >
              <img 
                src="https://acs.gedhemedia.com/AkademikaSupport_Primary.png" 
                alt="Academika Support Logo" 
                className="h-10 w-auto object-contain" 
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => handleLinkClick(link.path)}
                className={`${
                  isActive(link.path)
                    ? 'text-primary font-bold border-b-2 border-primary'
                    : 'text-primary font-medium hover:opacity-70'
                } transition-all py-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:rounded px-2`}
              >
                {link.name}
              </Link>
            ))}
            <Link 
              to="/kontak"
              className="focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:rounded-lg"
            >
              <button className="bg-primary text-white px-6 py-2.5 rounded-lg font-medium transition-all shadow-sm hover:opacity-90 active:scale-95">
                Konsultasi Sekarang
              </button>
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-primary focus:outline-none focus:ring-2 focus:ring-primary rounded-lg"
            aria-label={isMenuOpen ? "Tutup menu" : "Buka menu"}
            aria-expanded={isMenuOpen}
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" aria-hidden="true" />
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-6 border-t border-divider animate-in fade-in slide-in-from-top-4">
            <div className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => handleLinkClick(link.path)}
                  className={`${
                    isActive(link.path)
                      ? 'text-primary font-bold bg-gray-50'
                      : 'text-primary font-medium'
                  } px-4 py-2 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-primary`}
                >
                  {link.name}
                </Link>
              ))}
              <div className="px-4 pt-4">
                <Link to="/kontak" onClick={() => setIsMenuOpen(false)}>
                  <button className="bg-primary text-white px-6 py-3 rounded-lg font-medium w-full shadow-md">
                    Konsultasi Sekarang
                  </button>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;